import React from 'react'
import Layout from '../../components/Layout'
import '../index.css'
import { Link } from 'gatsby'

import analysts_Architect_INTJ_personality_header from '../../images/personality_types_details/analysts_Architect_INTJ_personality_header.svg'
import analysts_Architect_INTJ_romantic_relationships from '../../images/personality_types_details/analysts_Architect_INTJ_romantic_relationships.svg'
import circleforward from '../../images/personality_types_details/circleforward.png'
import circleback from '../../images/personality_types_details/circleback.png'

const intj_relationships_dating = () => {
    return (
        <Layout>
            <main className="q-td analyst architect">
                {/* --------------------mobile child nav bar------------------------ */}
                <nav className="top-tabs mobile-only" aria-label="Personality description">

                    <Link to='/personality-types/architect-intj-personality' className="tab with-progress">
                        <span className="title">Introduction</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-strengths-and-weaknesses" className="tab with-progress ">
                        <span className="title">Strengths and Weaknesses</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-relationships-dating" className="tab with-progress active">
                        <span className="title">Romantic Relationships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-friends" className="tab with-progress ">
                        <span className="title">Friendships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-parents" className="tab with-progress ">
                        <span className="title">Parenthood</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-careers" className="tab with-progress ">
                        <span className="title">Career Paths</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intjs-at-work" className="tab with-progress ">
                        <span className="title">Workplace Habits</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-conclusion" className="tab with-progress ">
                        <span className="title">Conclusion</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab premium">
                        <span className="title">Premium Profile</span>
                    </Link>

                </nav>
                {/* -------------------- picture and title-------------------------- */}
                <header className="type-header analyst architect">
                    <svg className="background" viewBox="0 0 1920 600" preserveAspectRatio="none">
                        <path className="st0" d="M400 598.9l1520-152.8v164.4H0v-288z"></path>
                        <path className="st1" d="M923.4 546.3l996.6-97.4V1.5h-851z"></path>
                    </svg>
                    <img src={analysts_Architect_INTJ_personality_header} className="scene" alt='loading...' />
                    <div className="type-info">
                        <h1><span>Architect</span> Personality</h1>
                        <div className="code">INTJ-A / INTJ-T</div>
                        <a href="#" className="difference">(What’s the difference?)</a>
                    </div>
                </header>


                {/* -------------------------side bar section------------------------------------- */}
                <div className="with-sidebars">

                    <div className="sidebar left">
                        <nav className="sections" id="sticky-sidebar" style={{ paddingTop: '50px' }}>
                            <div className="title">Explore This Type</div>
                            <ul>
                                <li className=""><Link to='/personality-types/architect-intj-personality'>Introduction</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-strengths-and-weaknesses">Strengths & Weaknesses</Link></li>
                                <li className="active"><Link to="/personality-types/architect-intj-relationships-dating">Romantic Relationships</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-friends">Friendships</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-parents">Parenthood</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-careers">Career Paths</Link></li>
                                <li className=""><Link to="/personality-types/architect-intjs-at-work">Workplace Habits</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-conclusion">Conclusion</Link></li>
                                <li className="premium"><Link to="/">Premium Profile</Link></li>
                            </ul>
                        </nav>
                        <daily-insight v-cloak personality-type="INTJ"></daily-insight>
                    </div>
                    {/* ----------------------------description pages of sidebar------------------------------------- */}

                    <article class="main description">

<h1>    Romantic Relationships
</h1>


    <blockquote>
<p>“Of all forms of caution, caution in love is perhaps the most fatal to true happiness.”</p>
<footer>Bertrand Russell</footer>
</blockquote>

<p>People with the Architect (INTJ) personality type approach romance the way they do most challenges: strategically, with clear-cut goals and a plan for reaching them. In a purely rational world, this approach would be foolproof. Alas, it ignores important factors that Architects sometimes dismiss – such as the unpredictability of human nature and affection.</p>

<p>For these personalities, finding a compatible partner can be a particular challenge. Rarely satisfied with things as they are, Architects are always developing a world in their minds that is more perfect than reality. Other people entering their world need to fit this fantasy in some way. But if Architects’ expectations and ideals for a partner are unrealistic, then no real person will be able to fulfill them in every way.</p>

<h2>The Rites of Dating</h2>

<p>Architects care about depth and intelligence, and they insist on honest, open communication. For them, a relationship that isn’t founded on these values is hardly worth pursuing.</p>

<p>It might not come as a surprise, then, that the social niceties and obscure etiquette of dating can seem useless or even insulting to Architect personality types. But many of these conventions exist for a reason – to help an inherently unpredictable situation seem a little less daunting. If Architects refuse to play along, they may find the dating world difficult, if not impossible.</p>

<div class="description-pullout">
As Architects often learn, the ways of love are hard to describe in a spreadsheet.
</div>

<p>As they mature and gain experience, many Architects eventually come to understand the purpose of romantic rituals. Until that point, however, they may decide that dating is too irrational or beneath them. Some people with this personality type might constantly try to demonstrate their intellectual superiority, as a way of proving that they’re above the “silliness” of dating. Obviously, this mindset is unlikely to help Architects find or connect with a partner.</p>

<p>Sometimes, Architects’ best strategy is to focus on what they enjoy rather than struggle against the rules of dating. Ironically, people with this personality type are often most attractive when they aren’t trying to be. Just doing what they do best – pursuing the interests that light them up – can help their confidence and intelligence shine.</p>

<div class="scene"><img alt="Architect (INTJ) romantic relationships" src={analysts_Architect_INTJ_romantic_relationships}/></div>

<h2>Emotion Sickness</h2>

<p>Architect personalities aren’t known for conventional shows of romance, such as sending flowers or writing mushy notes. Most Architects spend more time thinking about love than expressing it. But when they believe that a relationship has potential, Architects can give it their all, working to maintain stability and ensure their partner’s long-term satisfaction. And by using their imagination, people with this personality type can find meaningful, if unexpected, ways to share their affection.</p>

<div class="description-pullout">
Architects seek strong, meaningful relationships. They use their knowledge and logic to help ensure that their partner is satisfied.
</div>

<p>That said, emotions may still feel like a second language to these personalities. Rather than getting to the core of their relationship conflicts, Architects might treat them as puzzles to be solved – an approach that isn’t always successful. And when their partner shares strong feelings, Architects might shut down, or they may be tempted to analyze the situation rather than simply listening and offering support. For Architects, becoming comfortable with their partner’s emotions – and their own – can take more than a little practice.</p>

<p>Love is rarely easy, but it’s a challenge that can help Architects grow. Through their relationships, Architects can learn to focus on the present, get in touch with their emotions, remain involved with other people, and stay open to things they’re not used to. For a personality type so intent on self-development, these opportunities can make love even more satisfying.</p>

<div class="number">03</div>


</article>
                </div>

                <div className="navigation-buttons comp" data-chunk="type-chunk">
                    <div className="part left">
                    <Link to='/personality-types/architect-intj-strengths-and-weaknesses' className='next-feature'>
                        Strengths and Weaknesses
                       <br/><br/>
                       <img src={circleback} width={75} height={75}/>
                       </Link>
                    </div>
                    <div className="part right">
                       <Link to='/personality-types/architect-intj-friends'className='next-feature'>
                       Friendships
                       <br/><br/>
                       <img src={circleforward} width={75} height={75}/>
                       </Link>
                    </div>
                </div>

            </main>
        </Layout>
    )
}

export default intj_relationships_dating
